import {
  BaseIntegrationConfig,
  BaseIntegrationConfigRequest,
  CloudFormationSetupInfo,
  createIntegrationAPI,
} from "restAPI/GenericIntegrationAPI";

export const CROWDSTRIKE_EDR_INTEGRATION_TYPE = "CROWDSTRIKE_EDR_WEB";
export const CROWDSTRIKE_EDR_AUTH_TYPE = "API_KEY";
export const CROWDSTRIKE_EDR_DEFAULT_STATUS = "ACTIVE";

export interface CrowdStrikeEdrConfig extends BaseIntegrationConfig {
  authType: string;
  authConfig: {
    falconClientId: string;
    falconClientSecret: string;
    falconBaseUrl: string;
  };
  configProperties: {
    falconBaseUrl?: string;
  };
}

export interface CrowdStrikeEdrConfigRequest
  extends BaseIntegrationConfigRequest {
  uuid: string;
  status: string;
  authType: string;
  authConfig: {
    falconClientId: string;
    falconClientSecret: string;
    falconBaseUrl: string;
  };
  configProperties: {
    falconBaseUrl?: string;
  };
}

export type CrowdStrikeEdrSetupInfo = CloudFormationSetupInfo;

export const CrowdStrikeEdrAPI = createIntegrationAPI<
  CrowdStrikeEdrConfig,
  CrowdStrikeEdrConfigRequest
>(CROWDSTRIKE_EDR_INTEGRATION_TYPE);

export const falconBaseUrlValidator = {
  pattern: /^https:\/\/api[.a-z0-9-]*\.crowdstrike\.com$/,
  message: "Must be a valid Falcon API URL (e.g., https://api.crowdstrike.com)",
};
